import React from "react";
import { ThemeProvider, Typography } from "@mui/material";
import { theme } from "src/theme/theme";

import { useCompanyName } from "src/Pages/Company/CompanyContext";
import { getLanguage } from "src/utils/Languages/LanguageContext";
import __ from "src/utils/Translations";

import BreadcrumbsMui from "src/Components/BreadcrumbsMui/BreadcrumbsMui";
import DeductionConsentsTable from "./DeductionConsentsTable";

export default function DeductionConsents() {
  const companyName = useCompanyName();
  const language = getLanguage();

  const breadcrumbs = [
    {
      label: `${__("Zarządzanie firmą")} ${companyName}`,
      to: `/ahr`,
    },
    {
      label: __("Zgody na potrącenie"),
      to: `/ahr/deduction-consents`,
    },
  ];
  return (
    <ThemeProvider theme={theme({ language })}>
      <BreadcrumbsMui items={breadcrumbs} />
      <Typography
        variant="h4"
        sx={{ fontWeight: "fontWeightBold", mt: 3, mb: 2 }}
      >
        {`${__("Zgody na potrącenie")} ${companyName}`}
      </Typography>
      <Typography variant="body1" sx={{ mb: 3 }}>
        {__(
          "Przeglądaj zgody na potrącenie udzielone przez pracowników organizacji"
        )}
      </Typography>
      <DeductionConsentsTable />
    </ThemeProvider>
  );
}
